module.exports = __webpack_public_path__ + "media/images/bg/mosaic/temple-2794d049a6a5332438e450f85016188c.svg";